import React, {useCallback, useState} from 'react';
import {Link} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import {Button, Col, Row} from 'antd';

import useShowModalsActions from 'hooks/useShowModalsActions';
import {Gift} from 'types/index';

import * as actions from './actions';
import styles from './main.module.scss';
import ProjectStatistics from './components/ProjectStatistics';
import letterUrl from 'images/bg/veronika.jpg';

const WISH_DEADLINE_MONTH = 10;
const WISH_DEADLINE_DAY = 20;
const TIME_ZONE = 'Europe/Kyiv';

const isWishOpen = (): boolean => {
    const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: TIME_ZONE,
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
    });

    const parts = formatter.formatToParts(new Date());

    const getPart = (type: string): number => {
        return Number(parts.find(part => part.type === type)?.value);
    };

    const month = getPart('month');
    const day = getPart('day');

    return month < WISH_DEADLINE_MONTH || (month === WISH_DEADLINE_MONTH && day < WISH_DEADLINE_DAY);
};

const Home = (): JSX.Element | null => {
    const [showWishButton] = useState(isWishOpen);

    const {showCreateGiftModal} = useShowModalsActions();
    const dispatch = useDispatch();
    const showCreateGiftModalHandler = useCallback(() => {
        showCreateGiftModal((gift: Gift): void => {
            dispatch(actions.createGift(gift));
        });
    }, [dispatch, showCreateGiftModal]);
    return (
        <div className={styles.wrap}>
            <div className={styles.item}>
                <Row>
                    <Col sm={24} md={11}>
                        <div className="description">
                            <div className="description__title_small">Маленькі мрії мають велике значення</div>
                            <div className="description__title">
                                Стань Чарівником <br />
                                для дитини
                            </div>
                            Щороку фонд «Доброта та Довіра» допомагає дітям отримати подарунки, про які вони мріють до
                            Дня Святого Миколая. Обери дитяче бажання, підготуй подарунок і зроби одну маленьку мрію
                            реальністю.
                            <div className="description__img">
                                <img src={letterUrl} alt="letter" />
                            </div>
                            <div className="description__button">
                                <Link to="/gifts" className="ant-btn custom-btn custom-btn__action ant-btn-primary">
                                    СТАТИ ЧАРІВНИКОМ
                                </Link>
                                {showWishButton ? (
                                    <Button
                                        onClick={showCreateGiftModalHandler}
                                        className="custom-btn custom-btn__request"
                                    >
                                        ПОДАТИ ЗАЯВКУ
                                    </Button>
                                ) : null}
                            </div>
                        </div>
                    </Col>
                </Row>
                <ProjectStatistics />
            </div>
        </div>
    );
};

export default Home;
